import React from "react";
import { PhoneInput } from "react-international-phone";

import "react-international-phone/style.css";
import "../../Styles/CustomPhoneInput.css";


// ---------------------------------------------
// Get nested value from object
// Example:
// getInObject(values, "contact.contact_phone")
// ---------------------------------------------

const getInObject = (obj, path) => {
  if (!obj || typeof obj !== "object") {
    return undefined;
  }

  return path
    .split(".")
    .reduce((acc, key) => {
      return acc == null ? undefined : acc[key];
    }, obj);
};


const CustomPhoneInput = ({
  formik,
  name,
  value,
  onChange,

  disabled = false,
  defaultCountry = "us",
  placeholder = "",

  error = false,
  helperText = "",
}) => {


  // =============================================
  // 1. GET PHONE VALUE
  // =============================================

  let phoneValue = "";

  if (formik) {

    // Nested Formik value
    phoneValue =
      getInObject(formik.values, name) || "";

  } else {

    // Normal React state value
    phoneValue = value || "";
  }


  // =============================================
  // 2. HANDLE PHONE CHANGE
  // =============================================

  const handlePhoneChange = (phone) => {
    if (formik) {
      const current = getInObject(formik.values, name) ?? "";
      if (current !== phone) {
        // Update Formik
        formik.setFieldValue(name, phone);
      }
    } else if (onChange) {
      const current = value ?? "";
      if (current !== phone) {
        // Update normal React state
        onChange(phone);
      }
    }
  };


  // =============================================
  // 3. GET FORMik ERROR
  // =============================================

  const touchedValue = formik
    ? getInObject(formik.touched, name)
    : false;

  const errorValue = formik
    ? getInObject(formik.errors, name)
    : error;


  const hasError = formik
    ? Boolean(touchedValue && errorValue)
    : Boolean(error);


  // =============================================
  // 4. GET ERROR MESSAGE
  // =============================================

  const errorMessage = formik
    ? errorValue
    : helperText;


  // =============================================
  // 5. HANDLE BLUR
  // =============================================

  const handleBlur = () => {

    if (formik) {
      formik.setFieldTouched(name, true);
    }
  };


  // =============================================
  // 6. RETURN
  // =============================================

  return (
    <div className="custom-phone-wrapper">

      <PhoneInput

        defaultCountry={defaultCountry}

        value={phoneValue}

        onChange={handlePhoneChange}

        disabled={disabled}

        placeholder={placeholder}

        inputProps={{
          name: name,
          onBlur: handleBlur,
        }}

        className="w-100"
      />


      {/* Validation Error */}

      {hasError && (
        <div className="text-danger small mt-1">
          {errorMessage}
        </div>
      )}

    </div>
  );
};


export default CustomPhoneInput;